module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "expir-dialog-wrap"
  }, [_c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt,
      "widthnew": "450px",
      "heightnew": "520px"
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('div', {
    staticClass: "expir-bg"
  }, [_c('img', {
    staticClass: "expir-bg-img",
    attrs: {
      "src": require("../../../../assets/imgs/expir-dialog.png")
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "expri-tit"
  }, [_vm._v("尊贵的会员")]), _vm._v(" "), _c('p', {
    staticClass: "expri-tit"
  }, [_vm._v("您的会员卡已失效" + _vm._s(_vm.cvipMes.outdates) + "天")]), _vm._v(" "), _c('p', {
    staticClass: "expri-des"
  }, [_vm._v("该功能需要续费后才可使用哦")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-583cdc5e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/dialog/ExpriDialog.vue
// module id = F97/
// module chunks = 1